import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastService } from '../../../core/services/toast.service';
import { CryptoService } from 'src/app/core/helpers/crypto.service';
import { DpfService } from 'src/app/core/services/dpf.service';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-setup-profile-modal',
    templateUrl: './setup-profile-modal.component.html',
    styleUrls: ['./setup-profile-modal.component.scss'],
})
export class SetupProfileModalComponent implements OnInit {
    @Output() closed = new EventEmitter<void>();
    @Output() switchToLoginEvent = new EventEmitter<void>();
    @Output() switchToOtp = new EventEmitter<void>();

    // username = '';
    password = '';
    confirmPassword = '';
    isProfessional = false;

    showPassword = false;
    showConfirmPassword = false;

    companies = [];
    company = '';
    otherCompany = '';
    organizationEmail = '';
    linkedinUrl = '';

    lang = 'en';

    constructor(
        private dpfService: DpfService,
        private toast: ToastService,
        private appStateService: AppStateService,
        private translate: TranslateService,
        private cryptoService: CryptoService
    ) {}

    ngOnInit(): void {
        this.subscribeToLocaleChange();
        this.getCompanyUniversity();
    }

    subscribeToLocaleChange() {
        // Use unified 'locale' storage key with ISO language codes
        this.lang = sessionStorage.getItem('locale') || 'en';
        this.appStateService.localeObservable().subscribe((val) => {
            if (val) {
                this.lang = val;
            }
        });
    }

    getCompanyUniversity() {
        this.dpfService.getAllUniversity().subscribe((val) => {
            if (val?.status) {
                this.companies = val?.data;
                this.companies.push({ nameEn: 'Other' });
            }
        });
    }

    togglePassword() {
        this.showPassword = !this.showPassword;
    }

    toggleConfirmPassword() {
        this.showConfirmPassword = !this.showConfirmPassword;
    }

    close() {
        this.closed.emit();
    }

    isFormValid(): boolean {
        if (this.isProfessional) {
            if (
                (this.company || this.otherCompany) &&
                this.organizationEmail &&
                this.linkedinUrl
            ) {
                return (
                    this.password.trim() &&
                    this.password === this.confirmPassword
                );
            } else {
                return false;
            }
        } else {
            return (
                this.password.trim() &&
                this.password === this.confirmPassword
            );
        }
    }

    usernameError = false;
    submitted = false;
    onSubmit() {
        this.submitted = true;
        if (this.isProfessional) {
            if (
                !(this.company || this.otherCompany) ||
                !this.organizationEmail ||
                !this.linkedinUrl
            ) {
                return;
            }
        }
        if (this.isFormValid()) {
            const body = {
                password: this.cryptoService.encrypt(this.password.trim()),
                passwordConfirmation: this.cryptoService.encrypt(this.confirmPassword.trim()),
                companyOrUniversity: this.company || null,
                otherOrganizationName: this.otherCompany || null,
                organizationEmail: this.organizationEmail || null,
                profileLink: this.linkedinUrl || null,
            };
            this.dpfService.completeProfile(body).subscribe((val) => {
                if (val?.status) {
                    this.closed.emit();
                } else {
                    if (val?.message?.includes('1003')) {
                        const errorMsg = this.translate.instant('notifications.setupProfile.usernameExists');
                        this.toast.error(errorMsg);
                    }
                }
            });
        }
    }

    userNameChange() {
        this.usernameError = false;
    }
}
